import { useNavigate, Link } from "react-router-dom";
import Flex from "../../Tools/Flex";
import { Tab, Tabs, Button } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';

export default function Top(){

    const navigate = useNavigate()

    const tab = window.location.href.split('/').pop()

    return <Flex justifyContent='space-between' alignItems='center'>

        <Tabs value={tab} onChange={(e,v) => navigate(`/crm/${v}`)}>
            <Tab label="Groupements" value="groups" />
            <Tab label="Entreprises" value="firms" />
        </Tabs>

        <Flex>

            <Link to='/crm/groups/new'>
                <Button startIcon={<AddIcon/>}>
                    Groupement
                </Button>
            </Link>

            <Link to='/crm/firms/new'>
                <Button startIcon={<AddIcon/>}>
                    Entreprise
                </Button>
            </Link>

        </Flex>

    </Flex>
}